import { Controller, FieldValues, UseControllerProps } from "react-hook-form";

import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import type { SxProps } from "@mui/material/styles";

type CheckboxFormFieldProps = {
  testId?: string;
  sx?: SxProps;
  onClick?: (checked: boolean) => void;
  disabled?: boolean;
} & Omit<CheckboxProps, "onClick">;

export type RhfCheckboxFormFieldProps<T extends FieldValues> =
  CheckboxFormFieldProps & UseControllerProps<T>;

export default function CheckboxFormField<T extends FieldValues>({
  name,
  control,
  testId,
  onClick,
  disabled = false,
  sx,
  ...props
}: RhfCheckboxFormFieldProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, ...restField } }) => (
        <Checkbox
          {...props}
          data-testid={testId}
          checked={Boolean(value)}
          disabled={disabled}
          sx={sx}
          {...restField}
          onClick={(event) => {
            event.stopPropagation();
            onChange(event);
            //@ts-ignore
            onClick?.(Boolean(event.target.checked));
          }}
        />
      )}
    />
  );
}
